import { getSortBy, stringToNumberArray } from 'shared/utils'
import { getSkip } from 'shared/utils/getUrlParams'
import { ProjectsWithFilter } from 'store/action-creators/catalog'

export const projectListSize = 9

export const getProjectsParams = (
  query: {
    [key: string]: string
  },
  size = projectListSize,
  page?: number
): ProjectsWithFilter => {
  return {
    draftListId: query?.draftListId || query?.draftOpen, // при изменении названия параметра поменять и в админке корп сайта
    size: size,
    offset: getSkip(page || query?.page, projectListSize),
    searchString: query?.filmName,
    genre: stringToNumberArray(query?.filterGenre),
    ProjectType: stringToNumberArray(query?.filterFormat),
    ...getSortBy(query?.sortBy || 'position', 'name'),
  }
}
